<!--  -->
<template>
  <div class="product-card">
    <div class="product-top">
      <img class="product-img" :src="info.coverPic" />
      <div v-if="!info.useAble" class="product-disabled-msg df-jcc-aic bsbb">{{ info.unUseReason }}</div>
    </div>
    <div v-if="useSelect" class="product-select df-jcc-aic bsbb" :class="{'del': info.chooseFlag}" @click="onSelect(info.chooseFlag)">{{ info.chooseFlag ? '删除' : '选择'}}</div>
    <div class="product-bottom">
      <div class="flex-1">
        <div class="product-title ellipsis-2">{{ info.productName }}</div>
        <div class="product-promo-container">
          <div v-if="info.hasCoupon" class="product-promo-tag coupon"></div>
          <div v-if="info.hasProfitAdditional" class="product-promo-tag profit"></div>
          <div v-if="info.hasSuperHot" class="product-promo-tag hot"></div>
          <div v-if="info.hasSecKill" class="product-promo-tag seckill"></div>
        </div>
      </div>
      <div class="product-price">
        <p>结算价<span class="product-cur-price">¥{{ realPriceFormat(info.settlePrice) }}</span></p>
        <p>建议零售价<span class="product-cur-price">¥{{ realPriceFormat(info.salePrice) }}</span></p>
        <p>
          <span v-if="info.profit">佣金<span class="product-cur-price">¥{{realPriceFormat(info.profit)}}</span></span>
          <span v-if="info.profitRate">（佣金比例<span class="product-cur-price">{{info.profitRate}}%</span>）</span>
        </p>
      </div>
      <div class="product-info">
        <div style="margin-bottom: 6px">库存量：{{ info.skuTotalCount | volumeFormat }}</div>
        <div>品牌：{{ info.brandName }}</div>
        <div>类目：{{ info.categoryDesc }}</div>
        <div>款号：{{ info.styleNo }}</div>
        <div>播号：{{ info.productNum }}</div>
        <div>商品ID：{{ info.productId }}</div>
        <div>销售时间：{{ info.beginTime }}-{{ info.endTime }}</div>
      </div>
      <el-button class="product-promote" @click.stop="onCheckDetail(info.activityId, info.productId)">查看详情</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'productCard',
  components: {},
  props: {
    cardInfo: {
      type: Object
    },
    useSelect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    info () {
      return this.cardInfo || {};
    }
  },
  filters: {
    volumeFormat (num, origin = 100) {
      return num < origin ? `仅剩${num}件` : '库存充足';
    }
  },
  methods: {
    onCheckDetail (activityId, productId) {
      this.$router.push({
        name: 'productDetail',
        params: { activityId, productId }
      });
    },
    realPriceFormat (price) {
      return price ? (price / 100).toFixed(2) : 0;
    },
    onSelect (bol) {
      this.$emit('select', {
        type: bol ? 'REMOVE' : 'ADD',
        list: [
          {
            activityId: this.info.activityId,
            productId: this.info.productId
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-card {
  position: relative;
  width: 220px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #d8dce6;
  overflow: hidden;
  .product {
    &-top {
      flex-shrink: none;
      position: relative;
      width: 100%;
      height: 191px;
    }
    &-img {
      width: 100%;
      height: 100%;
    }
    &-disabled-msg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 115px;
      width: 115px;
      height: 115px;
      background: rgba($color: #000000, $alpha: 0.6);
      font-size: 14px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 20px;
      text-align: center;
      padding: 2px 25px 0;
    }
    &-select {
      height: 30px;
      background: #F0426A;
      color: #fff;
      cursor: pointer;
    }
    &-select.del {
      background: rgba(0,0,0,.55);
    }
    &-bottom {
      flex-grow: 1;
      padding: 8px;
      display: flex;
      flex-direction: column;
    }
    &-title {
      font-size: 12px;
      color: #333333;
      line-height: 16px;
    }
    &-promo-container {
      margin-top: 4px;
      display: flex;
    }
    &-promo-tag {
      margin-right: 4px;
      height: 18px;
      background-size: 100% 100%;
      &.coupon{
        width: 39px;
        background-image: url('../../views/home/image/icon-coupon.png');
      }
      &.profit{
        width: 30px;
        background-image: url('../../views/home/image/icon-profit.png');
      }
      &.hot{
        width: 40px;
        background-image: url('../../views/home/image/icon-hot.png');
      }
      &.seckill{
        width: 28px;
        background-image: url('../../views/home/image/icon-seckill.png');
      }
    }
    &-price {
      padding: 14px 0 18px;
      font-size: 11px;
      color: #999999;
      & p + p {
        margin-top: 4px;
      }
    }
    &-cur-price {
      margin-left: 2px;
      font-size: 14px;
      color: #F0426A;
      line-height: 20px;
    }
    &-info {
      font-size: 11px;
      color: #999999;
      line-height: 16px;
    }
    &-promote {
      margin-top: 4px;
    }
  }
}
</style>
